export enum EStempBtnDisabledStatus {
  UNKNOWN,
  ABSENCE,
  WORKING_TIME_REGULATION,
}
